// Base stylesheet needed for every page
import './scss/app.scss';

// Lazy load page depended scripts and stylesheets method
const loadComponent = async name => {
    const {default: component} = await import(`./${name}.js`);

    return component();
}

require('./scripts/footer');
require('./scripts/header');
require('./scripts/microcart');
require('./scripts/nav');
require('./scripts/searchform');
require('./scripts/wishlist');

// Include page depended scripts and styles example
if(document.querySelector('.js-page-homepage') !== null) {
    loadComponent('homepage');
} else if(document.querySelector('.js-page-collection') !== null) {
    loadComponent('collection');
} else if(document.querySelector('.js-page-product') !== null) {
    loadComponent('product');
} else if(document.querySelector('.js-page-cart') !== null) {
    loadComponent('cart');
} else if(document.querySelector('.js-page-customer') !== null) {
    loadComponent('customer');
}

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
